import AuthResetPassword from './CreatePassword';

export default AuthResetPassword;
